import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {IWelcomeMessage} from "../Interfaces/IWelcomeMessage";

const createWelcomeCard = async (payload: IWelcomeMessage): Promise<IWelcomeMessage> => {
    return new Promise<IWelcomeMessage>((resolve, reject) => {
        return AxiosConfig.instance.post(`/welcomecards`, payload).then(res => {
            const welcomeCard: IWelcomeMessage = res.data["inserted"][0];
            return resolve(welcomeCard);
        }).catch(error => {
            reject(error);
        });
    });
}

const getWelcomeCard = async (): Promise<IWelcomeMessage | undefined> => {
    return new Promise<IWelcomeMessage | undefined>((resolve) => {
        return AxiosConfig.instance.get(`/welcomecards`).then(res => {
            const items: IWelcomeMessage = res.data ?? undefined;
            return resolve(items);
        }).catch(() => {
            resolve(undefined);
        });
    });
}

const updateWelcomeCard = async (payload: IWelcomeMessage): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        return AxiosConfig.instance.put(`/welcomecards`, payload).then(() => {
            return resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

const WelcomeCardApi = {
    createWelcomeCard,
    getWelcomeCard,
    updateWelcomeCard,
}

export default WelcomeCardApi;